import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../utils/style";
import DataSourceCardComponent from "./DataSourceCardComponent";

type Prop = {
  title: string;
  icon?: IconProp;
  children?: ReactNode;
  items?: string[];
  expandedFile: string | null;
  setExpandedFile: (file: string | null) => void;
  setSelectedFileForVisualization: (file: string) => void;
};

function DataSourceCardContainer(props:  Prop) {
  const [showBody, setShowBody] = useState(true);

  return (
    <>
      <Card>
        <Card.Header
          as="h5"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
            background: Colors.GRAY,
            cursor: "pointer",
          }}
          onClick={() => setShowBody(!showBody)}
        >
          <FontAwesomeIcon icon={!showBody ? faChevronDown : faChevronUp} size="1x" />
          <div>{props.title}</div>
        </Card.Header>

        {showBody && (
          <Card.Body style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {props.items?.map((item, index) => (
              <DataSourceCardComponent
                key={index}
                title={item}
                icon={props.icon}
                isExpanded={props.expandedFile === item} 
                setExpandedFile={props.setExpandedFile} 
                setSelectedFileForVisualization={props.setSelectedFileForVisualization}
              />
            ))}
          </Card.Body>
        )}
      </Card>
    </>
  );
}

export default DataSourceCardContainer;